import React, { useState } from 'react';
import { Button, Typography, List, Card } from 'antd';
import { EllipsisOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import '../../styles/Stepper.css';

const { Text } = Typography;

export const DonationReview = ({ next, prev, platform, donationOptions }) => {

    const [dataSubmitted, setDataSubmitted] = useState(false);

    // GPT related states
    const [showGPTConversations,setShowGPTConversations] = useState(false);
    const [showGPTSharedConversations,setShowGPTSharedConversations] = useState(false);
    const [showGPTMessagefeedback,setShowGPTMessagefeedback] = useState(false);
    const [showGPTUploadedImages,setShowGPTUploadedImages] = useState(false);

        // Gemini related states
    const [showGeminiActivity, setShowGeminiActivity] = useState(false);
    const [showGoogleAIMode, setShowGoogleAIMode] = useState(false);
    const [showGoogleSearch, setShowGoogleSearch] = useState(false);

    // Claude related states
    const [showClaudeConversations, setShowClaudeConversations] = useState(false);
    const [showClaudeProjects, setShowClaudeProjects] = useState(false);

    // Deepseek related states 
    const [showDeepseekConversations,setShowDeepseekConversations] = useState(false);

    // Mistral related states
    const [showMistralConversations,setShowMistralConversations] = useState(false);

    // Grok related states
    const [showGrokConversations,setShowGrokConversations] = useState(false);
    const [showGrokProjects, setShowGrokProjects] = useState(false);
    const [showGrokTasks, setShowGrokTasks] = useState(false);
    const [showGrokMediaPosts, setShowGrokMediaPosts] = useState(false);

    
    const topText = 'It is important that you understand exactly what you are donating. Below, we have provided sample data that shows the form of your donation. This example has been tailored to the donation options you selected. Note, that the data shown in this screen are not real and are used only for informational purposes.'

    const chatgptDonationSummary = [
        {
            title: "Chat History",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Title",
                            description: "Replying to HR"
                        },
                        {
                            title: "Create time",
                            description: "1749806901.749113"
                        },
                        {
                            title: "conversation_id",
                            description: "abcde-124343bgfvb"
                        },
                        {
                            title: "default_model_slug",
                            description: "auto"
                        },
                        {
                            title: "mapping",
                            description: `
                                <i>User:</i>
                                I received the following offer letter email from HR and want to reply professionally.<br>
                                Hi <span style="color:red;">Alice</span>,
                                We are pleased to offer you the position of <span style="color:red;">Data Analyst</span> at Amazon.
                                Your Annual CTC will be <span style="color:red;">$200,000</span>, inclusive of all benefits and bonuses.
                                Please confirm your acceptance of this offer by replying to this email by Friday, 1st November 2025.
                                Best regards,
                                <span style="color:red;">Bob</span>
                                <span style="color:red;">HR</span>
                                <span style="color:red;">Amazon</span><br>

                                <i>GPT:</i>
                                <blockquote style="background:#f5f5f5; padding:10px; border-left:3px solid #1890ff;">
                                <b>Subject:</b> Re: Offer for Data Analyst Position<br><br>
                                Hi <span style="color:red;">Bob</span>,<br>
                                Thank you very much for extending the offer for the <span style="color:red;">Data Analyst</span> position at <span style="color:red;">Amazon</span>. 
                                I’m delighted to accept the offer. I truly appreciate the opportunity and look forward to contributing.<br>
                                Best regards,
                                <span style="color:red;">Alice</span>
                                </blockquote>
                            <span style="color:blue; font-weight:bold;">
                                Note: Please note that the conversations might contain other sensitive information (e.g., health / finance / relationship information) that may carry a risk of deanonymization. However, we will store your donated data on secured servers with strict access controls to protect your privacy.
                                </span>
                            `
                        },
                        {
                            title: "default_model_slug",
                            description: "auto"
                        },
                        {
                            title: "update time",
                            description: "749807095.968923"
                        }
                    
                    ]
                }
            ],
            showEllipses: true,
            showList: showGPTConversations,
            setShowList: setShowGPTConversations
        },
        {
            title: "Shared conversations",
            hide: !donationOptions.ChatGPTsharedConversations,
            data: [
                {
                    data: [
                        {
                            title: "ID",
                            description: "abcde12345"
                        },
                        {
                            title: "Conversation ID",
                            description: "12345xdvfbf-fvfvb"
                        },
                        {
                            title: "Title",
                            description: "Summary of calculus"
                        },
                        {
                            title: "is_anonymous",
                            description: "true"
                        },

                    ],
                }, {
                    data: [
                         {
                            title: "ID",
                            description: "xywza12345"
                        },
                        {
                            title: "Conversation ID",
                            description: "12345xyzbd-abcde"
                        },
                        {
                            title: "Title",
                            description: "Expectations from Medical Students"
                        },
                        {
                            title: "is_anonymous",
                            description: "true"
                        },
                    ]
                }
            ],
            showEllipses: true,
            showList: showGPTSharedConversations,
            setShowList: setShowGPTSharedConversations
        },
        {
            title: "Message Feedbacks",
            hide: !donationOptions.ChatGPTMessagefeedback,
            data: [
                {
                    data: [
                        {
                            title: "ID",
                            description: "abcde12345"
                        },
                        {
                            title: "Conversation ID",
                            description: "12345xdvfbf-fvfvb"
                        },
                        {
                            title: "User Id",
                            description: "Summary of calculus"
                        },
                        {
                            title: "Create time",
                            description: "2025-01-23T10:15:10.181206Z"
                        },
                        {
                            title: "workspace_id",
                            description: "null"
                        },
                        {
                            title: "content",
                            description: "{}"
                        },
                        {
                            title: "evaluation_name",
                            description: "gpt4o_ff_garden_memory_p13n_prompt_v2_free"
                        },
                        {
                            title: "evaluation_treatment",
                            description: "da"
                        },
                        {
                            title: "update time",
                            description: "2025-01-23T10:15:10.287469Z"
                        },

                    ],
                }
            ],
            showEllipses: true,
            showList: showGPTMessagefeedback,
            setShowList: setShowGPTMessagefeedback
        }
    ];

    const geminiDonationSummary = [
        {
            title: "Gemini Apps Activity",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Header",
                            description: "Gemini Apps"
                        },
                        {
                            title: "Title",
                            description: "Plan a weekend trip"
                        },
                        {
                            title: "Time",
                            description: "2025-12-03T14:50:00.053Z"
                        },
                        {
                            title: "Products",
                            description: "Gemini Apps"
                        },
                        {
                            title: "Activity Controls",
                            description: "Gemini Apps Activity"
                        },
                        {
                            title: "Content",
                            description: `
                                <i>User:</i>
                                I received the following offer letter email from HR and want to reply professionally.<br>
                                Hi <span style="color:red;">Alice</span>,
                                We are pleased to offer you the position of <span style="color:red;">Data Analyst</span> at Amazon.
                                Your Annual CTC will be <span style="color:red;">$200,000</span>, inclusive of all benefits and bonuses.
                                Please confirm your acceptance of this offer by replying to this email by Friday, 1st November 2025.
                                Best regards,
                                <span style="color:red;">Bob</span>
                                <span style="color:red;">HR</span>
                                <span style="color:red;">Amazon</span><br>

                                <i>Gemini:</i>
                                <blockquote style="background:#f5f5f5; padding:10px; border-left:3px solid #1890ff;">
                                <b>Subject:</b> Re: Offer for Data Analyst Position<br><br>
                                Hi <span style="color:red;">Bob</span>,<br>
                                Thank you very much for extending the offer for the <span style="color:red;">Data Analyst</span> position at <span style="color:red;">Amazon</span>. 
                                I’m delighted to accept the offer. I truly appreciate the opportunity and look forward to contributing.<br>
                                Best regards,
                                <span style="color:red;">Alice</span>
                                </blockquote>
                            <span style="color:blue; font-weight:bold;">
                                Note: Please note that the conversations might contain other sensitive information (e.g., health / finance / relationship information) that may carry a risk of deanonymization. We store your donated data on secured servers with strict access controls to protect your privacy.
                                </span>
                            `
                        }
                    ]
                }
            ],
            showEllipses: true,
            showList: showGeminiActivity,
            setShowList: setShowGeminiActivity
        }, 
        {
            title: "Google Search Content",
            hide: !donationOptions.GoogleSearchActivity,
            data: [
                {
                    data: [
                        {
                            title: "Title", 
                            description: "Searched for When is the next trash pickup on <span style=\"color:red; font-weight:bold;\">[Your Street Name]</span>?"
                        }, 
                        {
                            title: "URL", 
                            description: "https://www.welcome-to-rlp.org/project-communities/huetschenhausen/waste-management"
                        },
                        {
                            title: "Time", 
                            description: "2025-12-01T10:30:00.000Z"
                        }, 
                        {
                            title: "Deatils", 
                            description: "From <span style=\"font-weight:bold;\">Google Search</span>"
                        }, 
                        {
                            title: "Activity Control",
                            description: `Web & App Activity <br><br>
                            <span style="color:blue; font-weight:bold;">
                                Note: Search history may contain sensitive personal information such as health, finance, location or relationship details. 
                              </span>`
                        }, 

                    ]
                }
            ], 
            showEllipses: true,
            showList: showGoogleSearch,
            setShowList: setShowGoogleSearch
        }, 
        {
            title: "Google AI Mode",
            hide: !donationOptions.GoogleAIMode,
            data: [
                {
                   data: [
                        {
                            title: "Title", 
                            description: "Searched for <span style=\"font-weight:bold; color:red;\">why does my stomach hurt when I eat dairy?</span>"
                        }, 
                        {
                            title: "Title URL", 
                            description: "https://www.google.com/?udm\u003d50\u0026mstk\u003dAUtExfDa0DRa94QlaPKzI4U1IWOhxuK6W2GROlFoQ-k9WO3B_NHwbxTAHfVTi9rbFcstsMTs4Eo3u5iEvKvOC41GPQnOKMbxnP_emVJa9fQZSqnEWqMmEWF65HjDGGNwxY6BX9_c5VZ8-lUzy4c_0FeTQ4_RsM32G0J7spS3G-RyOOLso_Jg9urrgOkgie-a0cWcK1I8uuUdqFoZVVUZd_3udRCkzFJdtuzoIZvnOzaIDvW9m-hb5ijBmj-3oLMb-4GDJdfIhpYXFnGtxNJLCvFVJ2cQaTP-KzvlWQ0B6Va9ObkchhO6jr1qq-JZIlqy6I34HtF3wqRsWuWBXQ\u0026csuir\u003d1\u0026q\u003dwhy%20does%20popcorn%20make%20my%20stomach%20hurt"
                        },
                        {
                            title: "Time", 
                            description: "2025-12-01T10:30:00.000Z"
                        }, 
                        {
                            title: "Activity Control",
                            description: "Web & App Activity"
                        }, 
                        {
                            title: "Products",
                            description: `AI Mode <br><br>
                            <span style="color:blue; font-weight:bold;">
                                Note: AI Mode may contain sensitive personal information such as health, finance, location or relationship details. 
                              </span>`
                        }
                    ]
                }
            ], 
            showEllipses: true,
            showList: showGoogleAIMode,
            setShowList: setShowGoogleAIMode
        }
    ];

    const claudeDonationSummary = [
        {    title: "Claude Messages",
            hide: false, // or use an option flag like: !donationOptions.ClaudeConversations
            data: [
            {
                data: [
                { title: "Message UUID", description: "019b2808-00cd-7187-a87d-037ffe07e450" },
                { title: "Sender", description: "human" },
                { title: "Created at", description: "2025-12-16T16:39:32.030974Z" },
                { 
                    title: "Text", 
                    description: `
                    <i>User:</i>
                    I received the following offer letter email from HR and want to reply professionally.<br>
                    Hi <span style="color:red;">Alice</span>,
                    We are pleased to offer you the position of <span style="color:red;">Data Analyst</span> at Amazon.
                    Your Annual CTC will be <span style="color:red;">$200,000</span>, inclusive of all benefits and bonuses.
                    Please confirm your acceptance of this offer by replying to this email by Friday, 1st November 2025.
                    Best regards,
                    <span style="color:red;">Bob</span>
                    <span style="color:red;">HR</span>
                    <span style="color:red;">Amazon</span><br>
                `
                },
                { title: "Attachments", description: "[]" },
                { title: "Files", description: "[screenshot_email.png]" },
                ],
            },
            {
                data: [
                { title: "Message UUID", description: "019b2808-00cd-7187-a87d-0380717a648b" },
                { title: "Sender", description: "assistant" },
                { title: "Created at", description: "2025-12-16T16:39:42.359240Z" },
                {
                    title: "Text",
                    description:`
                    <i>Claude:</i>
                    Sure, here's a professional reply to the offer letter:<br>
                    <blockquote style="background:#f5f5f5; padding:10px; border-left:3px solid #1890ff;">
                    <b>Subject:</b> Re: Offer for Data Analyst Position<br><br>
                    Hi <span style="color:red;">Bob</span>,<br>
                    Thank you very much for extending the offer for the <span style="color:red;">Data Analyst</span> position at <span style="color:red;">Amazon</span>. 
                    I’m delighted to accept the offer. I truly appreciate the opportunity and look forward to contributing.<br>
                    Best regards,
                    <span style="color:red;">Alice</span>
                    </blockquote>
                    <span style="color:blue; font-weight:bold;">
                    Note: Please note that the conversations might contain other sensitive information (e.g., health / finance / relationship information) that may carry a risk of deanonymization. We store your donated data on secured servers with strict access controls to protect your privacy.
                    </span>`,
                },
                { title: "Attachments", description: "[]" },
                { title: "Files", description: "[]" },
                ],
            },
            ],
        
            showEllipses: true,
            showList: showClaudeConversations,
            setShowList: setShowClaudeConversations,
        },
        {
            title: "Claude Projects",
            hide: !donationOptions.ClaudeProjects,
            data: [
                {
                    data: [
                        { title: "Project ID", description: "019b2bd9-5cc9-74c2-9c71-1987b2dd5caa" },
                        { title: "Name", description: "Estate & Succession" },
                        { title: "Is private", description: "true" },
                        { title: "Description", description: "A secure workspace containing all versions of the Smith Family Estate documents." },
                        { title: "Created At", description: "2025-11-20T10:00:00.000Z" },
                        { title: "Updated At", description: "2025-12-15T15:30:00.000Z" },
                        { title: "Creator", description: `<span style="color:red; font-weight:bold;">alice.smith@gmail.com</span>` },
                        { title: "Prompts", description: "You are a neutral estate assistant. Never offer definitive legal advice, but help me organize and summarize these documents. Always flag if a request contradicts a clause in the 'Will_Final.pdf' and maintain a respectful, calm tone." },
                    ],
                }, 
            ], 
            showEllipses: true,
            showList: showClaudeProjects,
            setShowList: setShowClaudeProjects
        }, 
    ];

    const deepseekDonationSummary = [
        {
            title: "Chat History",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Title",
                            description: "Replying to HR"
                        },
                        {
                            title: "Created_at",
                            description: "2025-12-16T22:22:02.302000+08:00"
                        },
                        {
                            title: "Updated_at",
                            description: "2025-12-18T22:22:02.302000+08:00"
                        },
                        {
                            title: "mapping",
                            description: `
                                <i>User:</i>
                                I received the following offer letter email from HR and want to reply professionally.<br>
                                Hi <span style="color:red;">Alice</span>,
                                We are pleased to offer you the position of <span style="color:red;">Data Analyst</span> at Amazon.
                                Your Annual CTC will be <span style="color:red;">$200,000</span>, inclusive of all benefits and bonuses.
                                Please confirm your acceptance of this offer by replying to this email by Friday, 1st November 2025.
                                Best regards,
                                <span style="color:red;">Bob</span>
                                <span style="color:red;">HR</span>
                                <span style="color:red;">Amazon</span><br>

                                <i> DeepSeek:</i>
                                <blockquote style="background:#f5f5f5; padding:10px; border-left:3px solid #1890ff;">
                                <b>Subject:</b> Re: Offer for Data Analyst Position<br><br>
                                Hi <span style="color:red;">Bob</span>,<br>
                                Thank you very much for extending the offer for the <span style="color:red;">Data Analyst</span> position at <span style="color:red;">Amazon</span>. 
                                I’m delighted to accept the offer. I truly appreciate the opportunity and look forward to contributing.<br>
                                Best regards,
                                <span style="color:red;">Alice</span>
                                </blockquote>
                            <span style="color:blue; font-weight:bold;">
                                Note: Please note that the conversations might contain other sensitive information (e.g., health / finance / relationship information) that may carry a risk of deanonymization. However, we will store your donated data on secured servers with strict access controls to protect your privacy.
                                </span>
                            `
                        },
                        {
                            title: "files",
                            description: "[]"
                        },
                        {
                            title: "model",
                            description: "deepseek-chat"
                        }
                    
                    ]
                }
            ],
            showEllipses: true,
            showList: showDeepseekConversations,
            setShowList: setShowDeepseekConversations
        },
    ];

    const mistralDonationSummary = [
        {
            title: "Mistral Conversations",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Title",
                            description: "Replying to HR"
                        },
                        {
                            title: "Created_at",
                            description: "2025-12-16T22:22:02.302000+08:00"
                        },
                        {
                            title: "Updated_at",
                            description: "2025-12-18T22:22:02.302000+08:00"
                        },
                        {
                            title: "content",
                            description: `
                                <i>User:</i>
                                I received the following offer letter email from HR and want to reply professionally.<br>
                                Hi <span style="color:red;">Alice</span>,
                                We are pleased to offer you the position of <span style="color:red;">Data Analyst</span> at Amazon.
                                Your Annual CTC will be <span style="color:red;">$200,000</span >, inclusive of all benefits and bonuses.
                                Please confirm your acceptance of this offer by replying to this email by Friday, 1st November 2025.
                                Best regards,
                                <span style="color:red;">Bob</span>
                                <span style="color:red;">HR</span>
                                <span style="color:red;">Amazon</span><br>

                                <i> Mistral:</i>
                                <blockquote style="background:#f5f5f5; padding:10px; border-left:3px solid #1890ff;">
                                <b>Subject:</b> Re: Offer for Data Analyst Position<br><br>
                                Hi <span style="color:red;">Bob</span>,<br>
                                Thank you very much for extending the offer for the <span style="color:red;">Data Analyst</span> position at <span style="color:red;">Amazon</span>. 
                                I’m delighted to accept the offer. I truly appreciate the opportunity and look forward to contributing.<br>
                                Best regards,
                                <span style="color:red;">Alice</span>
                                </blockquote>
                            <span style="color:blue; font-weight:bold;">
                                Note: Please note that the conversations might contain other sensitive information (e.g., health / finance / relationship information) that may carry a risk of deanonymization. However, we will store your donated data on secured servers with strict access controls to protect your privacy.
                                </span>
                            `
                        },
                        {
                            title: "files",
                            description: "['screenshot_email.png']"
                        },
                        {
                            title: "User reaction",
                            description: "neutral"
                        }, 
                    ]
                }
            ],
            showEllipses: true,
            showList: showMistralConversations,
            setShowList: setShowMistralConversations
        },
    ];

    const grokDonationSummary = [
        {
            title: "Grok Conversations",
            hide: false,
            data: [
                {
                    data: [
                        {
                            title: "Title",
                            description: "Replying to HR"
                        },
                        {
                            title: "Created_at",
                            description: "2025-12-16T22:22:02.302000+08:00"
                        },
                        {
                            title: "Updated_at",
                            description: "2025-12-18T22:22:02.302000+08:00"
                        },
                        {
                            title: "content",
                            description: `
                                <i>User:</i>
                                I received the following offer letter email from HR and want to reply professionally.<br>
                                Hi <span style="color:red;">Alice</span>,
                                We are pleased to offer you the position of <span style="color:red;">Data Analyst</span> at Amazon.
                                Your Annual CTC will be <span style ="color:red;">$200,000</span >, inclusive of all benefits and bonuses.
                                Please confirm your acceptance of this offer by replying to this email by Friday, 1st November 2025.
                                Best regards,
                                <span style="color:red;">Bob</span>
                                <span style="color:red;">HR</span>
                                <span style="color:red;">Amazon</span><br>

                                <i> Grok:</i>
                                <blockquote style="background:#f5f5f5; padding:10px; border-left:3px solid #1890ff;">
                                <b>Subject:</b> Re: Offer for Data Analyst Position<br><br>
                                Hi <span style="color:red;">Bob</span>,<br>
                                Thank you very much for extending the offer for the <span style="color:red;">Data Analyst</span> position at <span style="color:red;">Amazon</span>. 
                                I’m delighted to accept the offer. I truly appreciate the opportunity and look forward to contributing.<br>             
                                Best regards,
                                <span style="color:red;">Alice</span>
                                </blockquote>
                            <span style="color:blue; font-weight:bold;">
                                Note: Please note that the conversations might contain other sensitive information (e.g., health / finance / relationship information) that may carry a risk of deanonymization. However, we will store your donated data on secured servers with strict access controls to protect your privacy.
                                </span>
                            `
                        },
                        {
                            title: "files",
                            description: "['screenshot_email.png']"
                        },
                        {
                            title: "Conversation starred", 
                            description: "false"
                        }

                    ]
                }
            ],
            showEllipses: true,
            showList: showGrokConversations,
            setShowList: setShowGrokConversations
        },
        {
            title: "Grok Projects",
            hide: !donationOptions.GrokProjects,
            data: [
                {
                    data: [
                        { title: "Project ID", description: "019b2bd9-5cc9-74c2-9c71-1987b2dd5caa" },
                        { title: "Name", description: "Estate & Succession" },
                        { title: "Is public", description: "false" },
                        { title: "View count", description: "0" },
                        { title: "Custom Personality", description: "You are a neutral estate assistant. Never offer definitive legal advice, but help me organize and summarize these documents. Always flag if a request contradicts a clause in the 'Will_Final.pdf' and maintain a respectful, calm tone."},
                        { title: "Created At", description: "2025-11-20T10:00:00.000Z" },
                        { title: "Updated At", description: "2025-12-15T15:30:00.000Z" },
                    ],
                }, 
            ], 
            showEllipses: true,
            showList: showGrokProjects,
            setShowList: setShowGrokProjects
        }, 
        {
            title: "Grok Tasks",
            hide: !donationOptions.GrokTasks,
            data: [
                {
                    data: [
                        { title: "Task ID", description: "019b2bd9-5cc9-74c2-9c71-1987b2dd5caa" },
                        { title: "Name", description: "Custom Newsletter" },
                        { title: "Prompt", description: "Provide a concise summary of the top news stories from the past 24 hours, focusing on politics, technology, and science. Include one key takeaway for each story. Format as a Custom Newsletter with date, edition, and sources from Grok's web lookups. Organize the newsletter to be easily digestible and readable." },
                        { title: "Schedule", description: "Weekly" },
                        { title: "Day of week", description: "Monday" },
                        { title: "Notification Method", description: "3" },
                        { title: "Created At", description: "2025-11-25T15:30:00.000Z" },
                        { title: "Updated At", description: "2025-12-10T12:00:00.000Z" },
                    ],
            }
            ],
            showEllipses: true,
            showList: showGrokTasks,
            setShowList: setShowGrokTasks
        }, 
        {
             title: 'Grok Media Posts', 
             hide: !donationOptions.GrokMediaPosts, 
             data: [
                {
                    data: [
                        { title: "Post ID", description: "019b2bd9-5cc9-74c2-9c71-1987b2dd5caa" },
                        { title: "Original prompt", description: "An astronaut floating in space.  " },
                        { title: "Media type", description: "Image" },
                        { title: "Media URL", description: "https://example.com/astronaut_image.png" },
                        { title: "Created At", description: "2025-12-01T10:00:00.000Z" },
                        { title: "Updated At", description: "2025-12-01T10:00:00.000Z" },
                    ]
                }
             ], 
            showEllipses: true,
            showList: showGrokMediaPosts,
            setShowList: setShowGrokMediaPosts
        }


    ];

    function SummaryListItem({ title, description }) {
        // return (
        //     <div><Text strong>{title}:</Text> {description}<br></br></div>
        // );
        return (
            <div>
                <Text strong>{title}:</Text>{' '}
                <span
                dangerouslySetInnerHTML={{ __html: description }}
                />
                <br />
            </div>
            );

    };

    function SummaryItem({ title, data, hide, showEllipses, showList, setShowList }) {

        return (
            <List.Item hidden={hide}>
                <List.Item.Meta
                    title={
                        <div>
                            {title}
                            <Button
                                type="text"
                                onClick={() => {
                                    setShowList(!showList)
                                }}
                                icon={showList ? <UpOutlined /> : <DownOutlined />}
                            />
                        </div>}
                    description={
                        <div>
                            <List
                                bordered
                                dataSource={data}
                                className="SummaryItem"
                                renderItem={item => (
                                    <List.Item hidden={!showList}>
                                        <List.Item.Meta
                                            description={
                                                item.data.map((listItem) => (
                                                    <SummaryListItem  {...listItem} />
                                                ))}
                                        />
                                    </List.Item>
                                )}

                            />
                            <EllipsisOutlined className="ellipses" hidden={!showEllipses || !showList} />
                        </div>} />
            </List.Item>
        )
    }

    return (
        <div>
            <div hidden={dataSubmitted}>
                <div className="Text">
                    <Card style={{ marginBottom: "8px" }}>
                        {topText}
                    </Card>
                    <Card className="standardCard">
                        <List >
                            {(platform === 'chatgpt') ?
                                chatgptDonationSummary.map((item, idx) => (
                                    <SummaryItem key={item.title + idx} {...item} />
                                )) : (platform === 'gemini') ?
                                geminiDonationSummary.map((item, idx) => (
                                    <SummaryItem key={item.title + idx} {...item} />
                                )) : (platform === 'claude') ?
                                claudeDonationSummary.map((item, idx) => (
                                    <SummaryItem key={item.title + idx} {...item} />
                                )) : (platform === 'deepseek') ? 
                                deepseekDonationSummary.map((item, idx) => (
                                    <SummaryItem key={item.title + idx} {...item} />
                                )) : (platform === 'mistral') ?
                                mistralDonationSummary.map((item, idx) => (
                                    <SummaryItem key={item.title + idx} {...item} />
                                )) : (platform === 'grok') ?
                                grokDonationSummary.map((item, idx) => (
                                    <SummaryItem key={item.title + idx} {...item} />
                                )) :
                                null
                            }
                        </List>
                    </Card>
                </div>
            </div>
            <div style={{ marginTop: "1em" }}>
                <Button
                    className="RightMargin"
                    onClick={prev}>
                    Previous
                </Button>
                <Button
                    type="primary"
                    onClick={next}>
                    Next
                </Button>
            </div>
        </div>
    )
};

export default DonationReview;